export const OPEN_NOW_SELLER_MODAL = 'open-now-seller-modal'

/**
 * Name of the hook used in elemts that open the NowSellerModal for a given sellerId
 * @param {*} sellerId the seller's id in now merchant center
 */
export const getNowSellerModalHook = sellerId =>
  `${OPEN_NOW_SELLER_MODAL}--${sellerId}`
